// extracted by mini-css-extract-plugin
module.exports = {"NewsSection":"NewsSection_NewsSection__169dK"};